<template>
    <Card :bordered="!hideMvps" :padding="20" :shadow="!hideMvps" dis-hover>
        <i-form :model="dados_projeto" :rules="rules_validate" label-position="top" ref="dados_projeto">
            <form-item prop="nome">
                <i-input class="nome_projeto" placeholder="Nome do Projeto" size="large"
                         v-model="dados_projeto.nome"></i-input>
            </form-item>
            <Row :gutter="16">
                <i-col span="8">
                    <form-item label="Responsável" prop="responsavel_id">
                        <i-select size="large" filterable clearable v-model="dados_projeto.responsavel_id">
                            <i-option :key="pessoa.value"
                                      :value="pessoa.value"
                                      v-for="pessoa in pessoas">{{ pessoa.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col span="8">
                    <form-item label="Tipo de projeto" prop="tipo_projeto_id">
                        <i-select size="large" filterable clearable v-model="dados_projeto.tipo_projeto_id">
                            <i-option :key="tipo.value" :value="tipo.value" v-for="tipo in tipos_projeto">{{ tipo.label
                                }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
            </Row>
            <form-item label="Resumo do projeto" prop="resumo">
                <i-input placeholder="Resumo do Projeto..." size="large" v-model="dados_projeto.resumo"></i-input>
            </form-item>
            <form-item label="Projeto details" prop="descricao_detalhada">
                <vue-editor :editorToolbar="editorToolbar" v-model="dados_projeto.descricao_detalhada"></vue-editor>
            </form-item>
            <template v-if="!hideMvps">
                <h5>MVP</h5>
                <Row :gutter="16" style="background:#f9f9f9;padding:10px;">
                    <i-col :key="item.unique || item.id_ticket" :lg="8" :md="12"
                           :xs="24" v-for="(item, index) in dados_projeto.mvps">
                        <mvp :modulos="modulos" :prop="`mvps.${ index }`" ref="mvp" v-model="dados_projeto.mvps[index]">
                            <template slot="extra">
                                <Icon style="font-size:40px;color:#5cb85c;" type="md-checkmark-circle-outline"
                                      v-if="item.status == 2 && item.andamento == 7"/>
                                <a @click.prevent="inativarMVP(index)" href="#" v-else>
                                    <Icon size="30" type="ios-close"></Icon>
                                </a>
                            </template>
                        </mvp>
                    </i-col>
                    <i-col :lg="8" :md="12" :xs="24">
                        <Card :padding="20" @click.native="adicionarMVP" class="card-add" dis-hover>
                            <form-item>
                                <Icon color="#dcdee2" size="135" type="ios-add"/>
                            </form-item>
                        </Card>
                    </i-col>
                </Row>
                <Row :gutter="16" style="background:#f9f9f9;padding:10px;margin-bottom:20px">
                    <i-col :key="item.unique || item.id_ticket" :lg="8" :md="12"
                           :xs="24" v-for="(item, index) in dados_projeto.mvps_inativos">
                        <mvp :modulos="modulos" :prop="`mvps_inativos.${ index }`" disabled
                             ref="mvp" v-model="dados_projeto.mvps_inativos[index]">
                            <div class="mvp-disabled">
                                <a @click.prevent="ativarMVP(index)" class="extra" href="#">
                                    <Icon size="30" type="ios-refresh"></Icon>
                                </a>
                            </div>
                        </mvp>
                    </i-col>
                </Row>
            </template>
        </i-form>
        <div class="floating-btn" v-show="ativar_botao">
            <i-button @click="validar('dados_projeto')" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
        <Modal footer-hide v-model="ver_imagem" width="1024">
            <img :src="url_imagem" style="width: 100%" v-if="ver_imagem">
        </Modal>
    </Card>
</template>

<script>
    import Mvp from './components/Mvp';
    import {find} from "lodash";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import {editorToolbar, moment} from "../../helpers/utils.js";
    import treeMixin from '../../mixins/tree';
    import {mapGetters} from "vuex";

    export default {
        components: {
            VueEditor: () =>
                import("vue2-editor").then(({VueEditor}) => VueEditor),
            vue2Dropzone: () => import("vue2-dropzone"),
            Mvp
        },
        name: "projeto",
        props: {
            id: [String, Number],
            hideMvps: {
                type: Boolean,
                default: false
            }
        },
        mixins: [treeMixin],
        data() {
            const validatorSelect = (rule, value, callback) => {
                if (value === 0) {
                    callback(new Error(rule.message));
                } else {
                    callback();
                }
            };
            return {
                unique: 1,
                url_upload: `${process.env.VUE_APP_API_URL}media/image`,
                url_imagem: "",
                ver_imagem: false,
                ativar_botao: false,
                dados_projeto: {
                    id_projeto: 0,
                    nome: "",
                    responsavel_id: 0,
                    tipo_projeto_id: 0,
                    resumo: "",
                    descricao_detalhada: "",
                    mvps: [],
                    mvps_inativos: []
                },
                rules_validate: {
                    nome: [
                        {
                            required: true,
                            message: "Digite um nome para o projeto",
                            trigger: "blur"
                        }
                    ],
                    responsavel_id: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe o responsável pelo projeto",
                            trigger: "change"
                        }
                    ],
                    tipo_projeto_id: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Escolha o tipo do projeto",
                            trigger: "change"
                        }
                    ],
                    resumo: [
                        {
                            required: true,
                            message: "Faça um resumo do que terá no projeto",
                            trigger: "blur"
                        }
                    ],
                    descricao_detalhada: [
                        {
                            required: true,
                            message:
                                "Informe com detalhes o que será implementado no projeto",
                            trigger: "blur"
                        }
                    ]
                },
                tipos_projeto: [],
                modulos: [],
                input_width: "100%",
                tip: ["Muito Baixo", "Baixo", "Médio", "Alto", "Muito Alto"],
                editorToolbar,
            };
        },
        computed: {
            ...mapGetters(['usuarios']),
            pessoas() {
                return this.usuarios.map(item => ({
                    value: item.id_pessoa,
                    label: item.nome
                }));
            }
        },
        methods: {
            montarDados(dados_projeto) {
                if (dados_projeto.responsavel_id) {
                    dados_projeto.responsavel_nome = find(
                        this.pessoas,
                        o => o.value == dados_projeto.responsavel_id
                    ).label;
                } else {
                    delete dados_projeto.responsavel_id;
                }

                if (dados_projeto.tipo_projeto_id) {
                    dados_projeto.tipo_projeto_nome = find(
                        this.tipos_projeto,
                        o => o.value == dados_projeto.tipo_projeto_id
                    ).label;
                } else {
                    delete dados_projeto.tipo_projeto_id;
                }
                if (dados_projeto.data_hora_registro) {
                    delete dados_projeto.data_hora_registro;
                }

                return JSON.parse(JSON.stringify(dados_projeto));
            },
            /**
             * Antes de Salvar valida os dados dos inputs
             */
            validar(name) {
                this.$refs[name].validate(valid => {
                    if (!valid) {
                        this.$Message.error("Há campos não informados!");
                    } else {
                        this.salvar();
                    }
                });
            },
            /**
             * Atualiza um cadastro existente, ou cria um novo
             */
            async salvar() {
                this.$Spin.show();
                const dados_projeto = this.montarDados(this.dados_projeto);
                try {
                    const id_projeto = this.dados_projeto.id_projeto;
                    const URI = `projeto`;
                    /**
                     * Cria um novo projeto
                     */
                    if (id_projeto == 0) {
                        const {data} = await this.$axios.post(
                            URI,
                            dados_projeto
                        );
                        this.dados_projeto.id_projeto = data.id;
                        this.dados_projeto.id_projeto = data.id;

                        data.mvps.ids.forEach(function (value, index) {
                            this.dados_projeto.mvps[index].id_ticket = value;
                        }, this);
                        data.mvps.anexos.forEach(function (value, index) {
                            this.dados_projeto.mvps[index].imagens = {
                                lista: value,
                                salvas: value,
                                enviadas: [],
                                removidas: []
                            };
                        }, this);
                        this.$emit('update', {
                            ...data.projeto,
                            mvps: this.dados_projeto.mvps
                        });
                    } else {
                        /**
                         * Edita o projeto
                         */
                        const {data} = await this.$axios.put(
                            `${URI}/${id_projeto}`,
                            dados_projeto
                        );
                        data.mvps.ids.forEach(function (value, index) {
                            this.dados_projeto.mvps[index].id_ticket = value;
                        }, this);
                        data.mvps.anexos.forEach(function (value, index) {
                            this.dados_projeto.mvps[index].imagens = {
                                lista: value,
                                salvas: value,
                                enviadas: [],
                                removidas: []
                            };
                        }, this);
                        this.$emit('update', {
                            ...data.projeto,
                            mvps: this.dados_projeto.mvps
                        });
                    }
                    if (!this.hideMvps) {
                        this.atualizarListaImagens();
                    }
                    this.$Message.success("Projeto salvo com sucesso!");
                    this.ativar_botao = false;
                    this.$Spin.hide();
                } catch (error) {
                    console.warn(error);
                    this.$Message.error(`Erro! ${error}`);
                    this.$Spin.hide();
                }
            },
            adicionarMVP() {
                this.unique++;
                this.dados_projeto.mvps.push({
                    unique: this.unique
                });
            },
            inativarMVP(index) {
                this.dados_projeto.mvps_inativos.push(
                    this.dados_projeto.mvps[index]
                );
                this.dados_projeto.mvps.splice(index, 1);
            },
            ativarMVP(index) {
                this.dados_projeto.mvps.push(
                    this.dados_projeto.mvps_inativos[index]
                );
                this.dados_projeto.mvps_inativos.splice(index, 1);
            },
            async getTreeModules() {
                this.modulos = await this.getChildren(1);
            },
            /**
             * Busca os dados do projeto para edição
             */
            async getProjeto(id_projeto) {
                try {
                    let {data} = await this.$axios.get(`projeto/${id_projeto}`);
                    /**
                     * Mapeia apenas os atributos necessários dos MVP
                     */
                    let mvps = data.mvps
                        .map(
                            ({
                                 ativo,
                                 id_ticket,
                                 resumo,
                                 descricao,
                                 tela_ux,
                                 descricao_tela_ux,
                                 horas_desenvolvimento,
                                 poker_time,
                                 esforco,
                                 status,
                                 andamento,
                                 modulo,
                                 funcao,
                                 funcionalidade,
                                 tela_ux_anexos
                             }) => {
                                tela_ux_anexos = tela_ux_anexos
                                    ? JSON.parse(tela_ux_anexos)
                                    : [];
                                return {
                                    ativo,
                                    id_ticket,
                                    resumo,
                                    descricao,
                                    tela_ux,
                                    descricao_tela_ux,
                                    horas_desenvolvimento:
                                        horas_desenvolvimento || 1,
                                    poker_time,
                                    esforco: (esforco - 6) * -1,
                                    status,
                                    andamento,
                                    imagens: {
                                        lista: tela_ux_anexos,
                                        salvas: tela_ux_anexos,
                                        enviadas: [],
                                        removidas: []
                                    },
                                    modulo,
                                    funcao,
                                    funcionalidade,
                                    functions: [],
                                    functionalities: [],
                                };
                            },
                            this
                        )
                        .sort((a, b) => {
                            if (a.peso > b.peso) {
                                return -1;
                            }
                            if (a.peso < b.peso) {
                                return 1;
                            }
                            // a must be equal to b
                            return 0;
                        });
                    data.mvps = mvps.filter(mvp => mvp.ativo == 1);
                    data.mvps_inativos = mvps.filter(mvp => mvp.ativo == 0);

                    this.dados_projeto = data;

                    setTimeout(() => {
                        this.ativar_botao = false;
                    }, 100);
                    this.$Spin.hide();
                } catch (error) {
                    console.warn(error);
                    this.$Spin.hide();
                }
            },
            async getTiposProjeto() {
                try {
                    const URI = `parametro/tiposProjeto`;
                    let {data} = await this.$axios.get(URI);

                    this.tipos_projeto = data.map(item => {
                        /**
                         * Notação do iview para funcionar o two way binding
                         */
                        return {
                            value: item.id_parametro,
                            label: item.descricao
                        };
                    });
                } catch (error) {
                    console.warn(error);
                }
            },
            /**
             * Após salvar as imagens no servidor
             * Remove as imagens enviadas do dropzone
             */
            atualizarListaImagens() {
                this.$refs.mvp.forEach((mvp, index) => {
                    this.$refs.mvp[index].dropzone.removeAllFiles();
                }, this);
            },
        },
        created() {
            /**
             * Popula os selects do formulário
             */
            this.getTreeModules();
            this.getTiposProjeto();
            /**
             * Caso tenha um id nas props consulto os dados do projeto [edição];
             */
            if (this.id > 0) {
                this.$Spin.show();
                this.getProjeto(this.id);
            } else {
                // this.adicionarMVP();
                setTimeout(() => {
                    this.ativar_botao = false;
                }, 100);
            }
        },
        watch: {
            /**
             * Observa alterações nos dados do projeto
             */
            dados_projeto: {
                handler() {
                    this.ativar_botao = true;
                },
                deep: true
            }
        }
    };
</script>

<style scoped>
    .card-add {
        min-height: 916px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        vertical-align: middle;
        margin: 10px 0px;
        text-align: center;
        border: 2px dashed #dcdee2;
        cursor: pointer;
    }
</style>
